import { Component, OnInit, Input, ContentChild, Output, EventEmitter } from "@angular/core";
import { FormControl } from "@angular/forms";

@Component({
    selector: "flow-input-counter",
    templateUrl: "./input-counter.component.html",
    styleUrls: ["./input-counter.component.scss"]
})
export class InputCounterComponent implements OnInit {

    constructor() { }

    ngOnInit() { }

    propagateChange: any = () => { };
    validateFn: any = () => { };

    @Input() item;
    @Input('datakey') datakey;
    @Input('counterValue') _counterValue = 0;
    @Input('counterRangeMax') counterRangeMax;
    @Input('counterRangeMin') counterRangeMin;
    @Output() eventChange = new EventEmitter();

    get counterValue() {
        return this._counterValue
    }

    set counterValue(val) {        
        this._counterValue = val;
        //this.eventChange.emit(true)
        this.propagateChange(val);
    }

    ngOnChanges(inputs) {
        if (inputs.counterRangeMax || inputs.counterRangeMin) {
            this.validateFn = createCounterRangeValidator(this.counterRangeMax, this.counterRangeMin);
            this.propagateChange(this.counterValue);
        }
    }

    writeValue(value) {
        if (value) {
            this.counterValue = value;
        }
    }

    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched() { }

    increase() {
        if (this.counterRangeMax >= (this.counterValue + 1)) {
            this.counterValue++;
            this.item[this.datakey] = this.counterValue
            this.eventChange.emit(this.item)
        }
    }

    decrease() {
        if (this.counterValue > this.counterRangeMin) {
            this.counterValue--
            this.item[this.datakey] = this.counterValue
            this.eventChange.emit(this.item)
        }
    }
    onBlur(event) {
        if (event.target.value) {

            if (parseFloat(event.target.value) <= this.counterRangeMax) {
                this.counterValue = parseFloat(event.target.value)
                this.item[this.datakey] = this.counterValue
                this.eventChange.emit(this.item)
            } else {
                event.target.value = ''
            }

        }
    }

    validate(c: FormControl) {
        return this.validateFn(c);
    }
    selectInput(event) {
        //isDebugMode ? console.log(`selectInput()`) : undefined
        event.target.select()
    }


}

export function createCounterRangeValidator(maxValue, minValue) {
    return (c: FormControl) => {
        let err = {
            rangeError: {
                given: c.value,
                max: maxValue || 10,
                min: minValue || 0
            }
        };

        return (c.value > +maxValue || c.value < +minValue) ? err : null;
    }
}